const ENABLED_CATEGORY_IDS = [51163, 51164];

const shouldShowModal = ({
  categoryId,
  loyaltyIsEnabled,
  loyaltyIsOptedIn,
  loyaltyNewInExperimentEnabled
}) => {
  const isEnabledCategory = ENABLED_CATEGORY_IDS.includes(categoryId);

  if (loyaltyNewInExperimentEnabled && isEnabledCategory) {
    return false;
  }

  return loyaltyIsEnabled && isEnabledCategory && !loyaltyIsOptedIn;
};

export default shouldShowModal;
